export interface IndustryExperience {
  industry: string
  years: number
  companies: string
  range: string
  countsTowardProductDesign: boolean
}

/**
 * Career experience by industry. Product-design years remain deliberately
 * separate from the earlier Bisk marketing, web, brand and video work.
 */
export const industryExperience: IndustryExperience[] = [
  {
    industry: 'Audit & Accounting',
    years: 5,
    companies: 'Deloitte, Chasm Communications',
    range: '2016 — 2021',
    countsTowardProductDesign: true,
  },
  {
    industry: 'Cybersecurity',
    years: 3,
    companies: 'Deepwatch',
    range: '2021 — 2024',
    countsTowardProductDesign: true,
  },
  {
    industry: 'Marketing, Web & Brand Design',
    years: 4,
    companies: 'Bisk Education',
    range: '2012 — 2016',
    countsTowardProductDesign: false,
  },
]

/** Years focused specifically on digital product design. */
export const productDesignYears = industryExperience
  .filter((item) => item.countsTowardProductDesign)
  .reduce((sum, item) => sum + item.years, 0)

/** Total years represented by the industry breakdown. */
export const industryExperienceYears = industryExperience.reduce(
  (sum, item) => sum + item.years,
  0,
)

/**
 * Total years working as a designer, including early agency experience.
 */
export const totalDesignYears = 14

export function shareOfIndustryExperience(years: number): number {
  return (years / industryExperienceYears) * 100
}

export interface CompanyRole {
  title: string
  range: string
}

export interface CompanyHistory {
  company: string
  /** Total years spent at the company, summed across all roles held there. */
  years: number
  roles: CompanyRole[]
}

/** Role history grouped by company, most recent first. */
export const roleHistory: CompanyHistory[] = [
  {
    company: 'Deepwatch',
    years: 3,
    roles: [
      { title: 'Product Design Lead', range: 'Apr 2023 — Jul 2024' },
      { title: 'Sr. Product Designer', range: 'Aug 2021 — Apr 2023' },
    ],
  },
  {
    company: 'Deloitte (through Chasm Communications)',
    years: 5,
    roles: [
      { title: 'Lead Sr. UI/UX Designer', range: 'May 2019 — Jul 2021' },
      { title: 'Sr. UI/UX Designer', range: 'Jul 2016 — May 2019' },
    ],
  },
  {
    company: 'Bisk Education',
    years: 4,
    roles: [
      { title: 'Senior Interactive Designer', range: 'May 2014 — Mar 2016' },
      { title: 'Interactive Designer', range: 'Oct 2012 — May 2014' },
      { title: 'Graphic Design Intern', range: 'Apr 2012 — Sep 2012' },
    ],
  },
]
